import Enumerable from "linq";

/**
 * 大文字・小文字を区別せず取得したいがinternalScriptsのほうを修正すると既存の処理に影響が出る可能性があるため、別で実装している
 */
export class ArgumentExtractor {
  constructor(private readonly _arguments: string[]) {
  }

  contains(key: string): boolean {
    const keyAsUpper = key.toUpperCase();
    return Enumerable.from(this._arguments).any(a => a.toUpperCase() === keyAsUpper);
  }

  getValue(key: string): string {
    const keyAsUpper = key.toUpperCase();
    for (let i = 0; i < (this._arguments.length - 1); ++i) {
      if (this._arguments[i].toUpperCase() !== keyAsUpper) {
        continue;
      }
      return this._arguments[i + 1];
    }
    return null;
  }
}
